import React from "react";
import { useIntl } from "react-intl";
import { MessageBanner, RadioButton } from "@folio/stripes/components";
import choiceCss from "./FreedPeriodChoice.module.css";
import css from "./NumberingChoiceFieldset.module.css";
export var NumberingChoiceFieldset = function (_a) {
    var name = _a.name, legend = _a.legend, warning = _a.warning, value = _a.value, options = _a.options, onChange = _a.onChange;
    var formatMessage = useIntl().formatMessage;
    return (React.createElement("fieldset", { className: choiceCss.fieldset },
        React.createElement("legend", { className: choiceCss.legend }, legend),
        warning && React.createElement(MessageBanner, { type: "warning" }, warning),
        options.map(function (option) {
            var checked = option.value === value;
            var disabled = Boolean(option.disabledReason);
            return (React.createElement("div", { key: option.value, className: "".concat(choiceCss.option, " ").concat(checked ? choiceCss.optionChecked : "", " ").concat(disabled ? choiceCss.optionDisabled : "") },
                React.createElement(RadioButton, { id: "".concat(name, "-").concat(option.value), name: name, value: option.value, checked: checked, disabled: disabled, onChange: function () { return onChange(option.value); }, label: React.createElement(React.Fragment, null,
                        option.title,
                        option.recommended && (React.createElement("span", { className: choiceCss.tag }, formatMessage({
                            id: "ui-br-legaldeposits.periodicalCheck.settings.numbering.recommended",
                        })))) }),
                React.createElement("div", { className: choiceCss.description }, option.description),
                option.disabledReason && (React.createElement("div", { className: css.reason }, option.disabledReason))));
        })));
};
